// import React from 'react';
// import { useTranslation } from 'react-i18next';

// const PhototherapyPage = ({ onButtonClick, onBack }) => {
//   const { t } = useTranslation();
  
//   const phototherapyServices = [
//     { name: t('phototherapyPage.services.face'), price: t('phototherapyPage.prices.face') },
//     { name: t('phototherapyPage.services.nose'), price: t('phototherapyPage.prices.nose') },
//     { name: t('phototherapyPage.services.cheeks'), price: t('phototherapyPage.prices.cheeks') },
//     { name: t('phototherapyPage.services.chin'), price: t('phototherapyPage.prices.chin') },
//     { name: t('phototherapyPage.services.neck'), price: t('phototherapyPage.prices.neck') },
//     { name: t('phototherapyPage.services.decollete'), price: t('phototherapyPage.prices.decollete') },
//     { name: t('phototherapyPage.services.forehead'), price: t('phototherapyPage.prices.forehead') },
//     { name: t('phototherapyPage.services.hands'), price: t('phototherapyPage.prices.hands') },
//     { name: t('phototherapyPage.services.elbows'), price: t('phototherapyPage.prices.elbows') },
//     { name: t('phototherapyPage.services.armsAbove'), price: t('phototherapyPage.prices.armsAbove') },
//     { name: t('phototherapyPage.services.faceNeck'), price: t('phototherapyPage.prices.faceNeck') },
//     { name: t('phototherapyPage.services.neckDecollete'), price: t('phototherapyPage.prices.neckDecollete') },
//     { name: t('phototherapyPage.services.faceNeckDecollete'), price: t('phototherapyPage.prices.faceNeckDecollete') },
//     { name: t('phototherapyPage.services.faceNeckDecolleteHands'), price: t('phototherapyPage.prices.faceNeckDecolleteHands') },
//     { name: t('phototherapyPage.services.backHalf'), price: t('phototherapyPage.prices.backHalf') },
//     { name: t('phototherapyPage.services.area1'), price: t('phototherapyPage.prices.area1') },
//     { name: t('phototherapyPage.services.area2'), price: t('phototherapyPage.prices.area2') },
//     { name: t('phototherapyPage.services.flash'), price: t('phototherapyPage.prices.flash') },
//     { name: t('phototherapyPage.services.back'), price: '' }
//   ];

//   const handleServiceClick = (serviceName, servicePrice) => {
//     if (serviceName === t('phototherapyPage.services.back')) {
//       onBack();
//     } else {
//       onButtonClick(serviceName, servicePrice);
//     }
//   };

//   return (
//     <>
//       <header className="header">
//         <div className="clinic-logo">
//           <div className="logo-icon">💡</div>
//           <h1>{t('phototherapyPage.title')}</h1>
//         </div>
        
//         <div className="user-greeting">
//           <p>{t('phototherapyPage.subtitle')}</p>
//         </div>
//       </header>

//       <main className="main-content">
//         <div className="welcome-section">
//           <h2>{t('phototherapyPage.welcome')}</h2>
//           <p className="subtitle">{t('phototherapyPage.lightTherapy')}</p>
//           <p className="description">{t('phototherapyPage.description')}</p>
//         </div>

//         <div className="buttons-grid">
//           {phototherapyServices.map((service, index) => (
//             <button 
//               key={index}
//               className={`service-btn ${service.name === t('phototherapyPage.services.back') ? 'back-btn' : ''}`}
//               onClick={() => handleServiceClick(service.name, service.price)}
//             >
//               <div className="service-info-full">
//                 <span className="service-name-full">{service.name}</span>
//                 {service.price && <span className="service-price">{service.price}</span>}
//               </div>
//             </button>
//           ))}
//         </div>
//       </main>

//       <footer className="footer">
//         <p>{t('phototherapyPage.footer.main')}</p>
//         <p className="footer-info">{t('phototherapyPage.footer.info')}</p>
//       </footer>
//     </>
//   );
// };

// export default PhototherapyPage;




import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const PhototherapyPage = ({ onButtonClick, onBack }) => {
  const { t } = useTranslation();
  const [selectedServices, setSelectedServices] = useState([]);
  
  const phototherapyServices = [
    { id: 1, name: t('phototherapyPage.services.face'), price: t('phototherapyPage.prices.face') },
    { id: 2, name: t('phototherapyPage.services.nose'), price: t('phototherapyPage.prices.nose') },
    { id: 3, name: t('phototherapyPage.services.cheeks'), price: t('phototherapyPage.prices.cheeks') },
    { id: 4, name: t('phototherapyPage.services.chin'), price: t('phototherapyPage.prices.chin') },
    { id: 5, name: t('phototherapyPage.services.neck'), price: t('phototherapyPage.prices.neck') },
    { id: 6, name: t('phototherapyPage.services.decollete'), price: t('phototherapyPage.prices.decollete') },
    { id: 7, name: t('phototherapyPage.services.forehead'), price: t('phototherapyPage.prices.forehead') },
    { id: 8, name: t('phototherapyPage.services.hands'), price: t('phototherapyPage.prices.hands') },
    { id: 9, name: t('phototherapyPage.services.elbows'), price: t('phototherapyPage.prices.elbows') },
    { id: 10, name: t('phototherapyPage.services.armsAbove'), price: t('phototherapyPage.prices.armsAbove') },
    { id: 11, name: t('phototherapyPage.services.faceNeck'), price: t('phototherapyPage.prices.faceNeck') },
    { id: 12, name: t('phototherapyPage.services.neckDecollete'), price: t('phototherapyPage.prices.neckDecollete') },
    { id: 13, name: t('phototherapyPage.services.faceNeckDecollete'), price: t('phototherapyPage.prices.faceNeckDecollete') },
    { id: 14, name: t('phototherapyPage.services.faceNeckDecolleteHands'), price: t('phototherapyPage.prices.faceNeckDecolleteHands') },
    { id: 15, name: t('phototherapyPage.services.backHalf'), price: t('phototherapyPage.prices.backHalf') },
    { id: 16, name: t('phototherapyPage.services.area1'), price: t('phototherapyPage.prices.area1') },
    { id: 17, name: t('phototherapyPage.services.area2'), price: t('phototherapyPage.prices.area2') },
    { id: 18, name: t('phototherapyPage.services.flash'), price: t('phototherapyPage.prices.flash') }
  ];

  const toggleService = (serviceId) => {
    if (selectedServices.includes(serviceId)) {
      setSelectedServices(selectedServices.filter(id => id !== serviceId));
    } else {
      setSelectedServices([...selectedServices, serviceId]);
    }
  };

  const handleBookAppointment = () => {
    const selectedServiceNames = phototherapyServices
      .filter(service => selectedServices.includes(service.id))
      .map(service => `${service.name} - ${service.price}`);
    
    if (selectedServiceNames.length > 0) {
      onButtonClick(`Запись на фототерапию: ${selectedServiceNames.join('; ')}`);
    } else {
      onButtonClick('Запись на консультацию по фототерапии');
    }
  };

  const totalPrice = phototherapyServices
    .filter(service => selectedServices.includes(service.id))
    .reduce((sum, service) => {
      const priceStr = service.price.replace(' руб.', '').replace(/\s/g, '');
      return sum + (parseInt(priceStr) || 0);
    }, 0);

  return (
    <>
      <header className="header">
        <div className="clinic-logo">
          <div className="logo-icon">💡</div>
          <h1>{t('phototherapyPage.title')}</h1>
        </div>
        
        <div className="user-greeting">
          <p>{t('phototherapyPage.subtitle')}</p>
        </div>
      </header>

      <main className="main-content">
        <div className="welcome-section">
          <h2>{t('phototherapyPage.welcome')}</h2>
          <p className="subtitle">{t('phototherapyPage.lightTherapy')}</p>
          <p className="description">{t('phototherapyPage.description')}</p>
        </div>

        <div className="services-list-section">
          <div className="services-scroll-container">
            {phototherapyServices.map((service) => (
              <div 
                key={service.id}
                className={`service-item ${selectedServices.includes(service.id) ? 'selected' : ''}`}
                onClick={() => toggleService(service.id)}
              >
                <div className="service-checkbox">
                  {selectedServices.includes(service.id) ? '✓' : ''}
                </div>
                <div className="service-info-full" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                  <span className="service-name-full" style={{ color: 'white' }}>{service.name}</span>
                  {service.price && (
                    <span className="service-price" style={{ color: 'white' }}>{service.price}</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {selectedServices.length > 0 && (
          <div className="services-total" style={{ margin: '20px 0', padding: '15px', background: 'rgba(255,255,255,0.1)', borderRadius: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span className="total-label" style={{ color: 'white' }}>Выбрано зон:</span>
            <span className="total-count" style={{ background: 'rgba(52,152,219,0.3)', padding: '5px 12px', borderRadius: '20px', color: 'white' }}>{selectedServices.length}</span>
            <span className="total-price" style={{ color: '#2ecc71', fontSize: '18px', fontWeight: '700' }}>{totalPrice} руб.</span>
          </div>
        )}

        <div className="buttons-grid">
          <button 
            className="service-btn book-btn" 
            onClick={handleBookAppointment}
            style={selectedServices.length > 0 ? { background: 'linear-gradient(135deg, rgba(39, 174, 96, 0.9), rgba(46, 204, 113, 0.9))' } : {}}
          >
            <span className="btn-icon">📅</span>
            <span className="btn-text" style={{ color: 'white' }}>
              {selectedServices.length > 0 ? 'Записаться на выбранные зоны' : 'Записаться на консультацию'}
            </span>
          </button>

          <button 
            className="service-btn back-btn"
            onClick={onBack}
          >
            <span className="btn-icon">←</span>
            <span className="btn-text" style={{ color: 'white' }}>{t('phototherapyPage.services.back')}</span>
          </button>
        </div>
      </main>

      <footer className="footer">
        <p>{t('phototherapyPage.footer.main')}</p>
        <p className="footer-info">{t('phototherapyPage.footer.info')}</p>
      </footer>
    </>
  );
};

export default PhototherapyPage;